import React, { useState, useEffect } from 'react';
import { Select } from 'tea-component';
import Tag from '@sg/components/Tag';

interface ISustainabilitySelectProps {
  initialValue: string;
  isCategory: boolean;
  onChange: (value: string) => void;
}

const SustainabilitySelect: React.FC<ISustainabilitySelectProps> = ({ initialValue, isCategory, onChange }) => {
  const [value, setValue] = useState(initialValue);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  
  useEffect(() => {
    if (isFirstLoad) {
      setIsFirstLoad(false);
    }
  }, [isFirstLoad]);
  
  // 当 initialValue 变化时更新内部状态
  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);
  
  const sustainabilityOptions = [
    { text: 'On Track', value: 'On Track' },
    { text: 'Overconsumed', value: 'Overconsumed' },
  ];
  
  const handleChange = (newValue: string) => {
    setValue(newValue); // 更新内部状态
    if (!isFirstLoad) {
      onChange(newValue); // 通知父组件
    }
  };
  
  // 阻止鼠标事件冒泡
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };
  
  const handleMouseDown = (e: React.MouseEvent) => {
    e.stopPropagation();
  };
  
  if (!isCategory) {
    // 二级目录（项目）：显示下拉单选框
    return (
      <div onClick={handleClick} onMouseDown={handleMouseDown}>
        <Select
          style={{ width: '100%' }}
          appearance="button"
          options={sustainabilityOptions}
          value={value || ''}
          onChange={handleChange}
          placeholder="Select"
        />
      </div>
    );
  } else {
    // 一级目录（分类）：显示标签或文本
    return value ? <Tag text={value} type={value === 'Overconsumed' ? "warn" : 'default'} /> : null;
  }
};

export default SustainabilitySelect;

